// Max supported depth is six levels! See i18n-dotize!!
export const de = {
  license: {
    breadcrumbTitle: 'Lizenzprüfung',
    pageTitle: 'Customfield Editor for Jira',
    errorTitle: 'Ungültige Lizenz',
    errorMessage: 'Die App hat keine gültige Lizenz. Bitte beziehen Sie eine gültige Lizenz über den Atlassian Marketplace.',
    notice: {
      paragraph1: 'Die App hat keine gültige Lizenz. Bitte beziehen Sie eine gültige Lizenz über den Atlassian Marketplace.',
    },
  },
  permissions: {
    headline: 'Feld:',
    globalPermission: 'Globale Berechtigungen',
    contextPermission: 'Kontext Berechtigungen',
    groupPermissions: 'Gruppen Berechtigungen',
    userPermissions: 'Benutzer Berechtigungen',
    editGlobalPermissions: 'Globale Feld Berechtigungen',
    editContextPermissions: 'Kontext Feld Berechtigungen',
  },
  global: {
    pageLoadFailErrorHeadline: 'Customfield Editor for Jira',
    pageLoadFailErrorSectionHeadline: 'Zugriff auf Jira REST API nicht möglich',
    modalCloseFieldEditorLevel: 'Schließe Level',
    noPermissionsEmptyText: 'Keine Berechtigungen erteilt',
    help: {
      youCanGetMoreInfo: 'Weitere Informationen findest du in der ',
      documentationButton: 'Dokumentation',
    },
    modalClose: 'Schließen',
    searchFieldPlaceholder: 'Suche',
    permission: {
      groups: 'Gruppen',
      users: 'Benutzer',
      remove: 'Berechtigung löschen',
    },
    customfieldTypes: {
      select: 'Select List (single choice)',
      cascadingselect: 'Select List (cascading)',
      multiselect: 'Select List (multiple choices)',
      multicheckboxes: 'Checkboxes',
      radiobuttons: 'Radio Buttons',
      textfield: 'Textfield',
      incompatible: 'Inkompatibler Feld Typ',
    },
    confirm: {
      yes: 'Ja',
      no: 'Nein',
    },
    search: {
      placeholder: 'Suche ...',
    },
    product: {
      headline: 'Customfield Editor for Jira',
      titleInfix: 'Customfield Editor for Jira',
      onlineHelp: 'Online Hilfe',
      licenseHelp: 'Lizenz Hilfe',
    },
    notFound: {
      pageTitle: 'Nicht Gefunden',
    },
    navigation: {
      fieldEditor: 'Feld Editor',
      permissionEditor: 'Berechtigungs Editor',
      adminSettings: 'Globale Einstellungen',
      restApiExplorer: 'REST API Explorer',
    },
    pagination: {
      prevLabel: 'Vorherige',
      nextLabel: 'Nächste',
      showingA: 'Zeige',
      showingB: 'von',
      showingC: ' Ergebnissen beginnend mit',
      processedA: 'Verarbeitet in',
      processedB: 'ms',
    },
  },
  admin: {
    list: {
      pageTitle: 'Berechtigungs Editor',
      subTitle: 'Alle kompatiblen Customfields',
      breadcrumbTitle: 'Feldliste',
      tableHead: {
        id: 'ID',
        type: 'Typ',
        name: 'Feldname',
        contexts: 'Kontexte',
        permissions: {
          users: 'Benutzer',
          groups: 'Gruppen',
        },
        projects: 'Projekte',
        issueTypes: 'Issue Typen',
      },
      globalPermissions: {
        title: 'Globale Berechtigung',
        subTitle: 'Benutzer oder Gruppen mit dieser Berechtigung können auf allen Kontexten arbeiten.',
      },
      showUsersGroupsButtonLabel: {
        true: 'verstecke Benutzer/Gruppen',
        false: 'zeige Benutzer/Gruppen',
      },
      viewButtonLabel: 'zeige Feldkontexte',
      results: {
        noResultsOnFilter: 'Die Suche ergab keine Ergebnisse.',
        noResultsWithoutFilter: 'Keine Felder gefunden. Möglicherweise existieren keine kompatiblen Felder.',
      },
    },

    edit: {
      pageTitle: 'Permission Editor',
      subTitle: 'Editere Customfield Berechtigungen',
      breadcrumbTitle: 'Editere Feld Berechtigungen',
    },
    listContext: {
      pageTitle: 'Permission Editor',
      subTitle: 'Wähle Feld Context',
      breadcrumbTitle: 'Kontextliste',
      tableHead: {
        id: 'ID',
        name: 'Contextname',
      },
    },
  },
  user: {
    list: {
      pageTitle: 'Customfield Editor for Jira',
      subTitle: 'Felder auf die du Zugriff hast',
      breadcrumbTitle: 'Customfields',
      notice: {
        paragraph1: 'Der Customfield Editor beinhaltet alle Customfields für die dir dein Administrator Berechtigungen erteilt hat.',
        paragraph2: 'Filtere mit Hilfe der Suche nach der Customfield ID oder dem Namen.',
        paragraph3: 'Klicke auf das ___ICON_EDIT___ Stift Icon, um die Optionen für ein Customfield in einem spezifischen Kontext zu bearbeiten.',
        admin: {
          paragraph1: 'Als Administrator kannst du anderen Benutzern Berechtigungen erteilen.',
          paragraph2: 'Klicke auf das ___ICON_EDIT___ Stift Icon, um Benutzern oder Grupppen Berechtigungen für ein Customfield in einem spezifischen Kontext zu erteilen.',
          paragraph3: 'Oder Klicke auf das ___ICON_USERGROUP___ Benutzer Icon, um Benutzern oder Grupppen Berechtigungen für alle Kontexte eines Customfields zu erteilen.',
        },
      },
      fieldIsLocked: 'Das Feld ist durch Jira oder eine andere App gesperrt und kann nicht bearbeitet werden.',
      fieldIsNotCompatible: 'Der Feld-Typ ist nicht kompatibel und kann nicht bearbeitet werden.',
      hasGlobalPermission: {
        title: 'Berechtigungen',
        yes: 'Du hast globale Berechtigung und kannst auf allen Kontexten arbeiten.',
        no: 'Du hast Berechtigungen für spezifische Kontexte.',
      },
      tableHead: {
        id: 'ID',
        type: 'Typ',
        name: 'Feldname',
        contexts: 'Kontexte',
        projects: 'Projekte',
        issueTypes: 'Vorgangs Typen',
        permission: 'Berechtigung',
      },
      editButtonLabel: 'Feld Kontexte',
      editOptionsButton: 'Editiere Optionen',
      results: {
        noResultsOnFilter: 'Die Suche ergab keine Ergebnisse.',
        noResultsOnFilterDescription: 'Versuche einen anderen Suchbegriff einzutippen oder lösche den Suchfilter.',
        noResultsWithoutFilter: 'Keine Felder gefunden',
        noResultsWithoutFilterDescription: 'Frage deinen Administrator nach Feldberechtigungen.',
      },
      noContextInCustomfield: {
        title: 'Kein Context vorhanden',
        details: 'Ein Feld ohne Context ist nicht editierbar. Fragen sie ihren Jira Administrator einen Standard oder Projekt Context anzulegen.',
      },
    },
    editOptions: {
      breadcrumbTitle: 'Editiere Optionen',
    },
    edit: {
      pageTitle: 'Editiere Customfield Optionen',
    },
    restApi: {
      pageTitle: 'REST API Explorer',
    },
    listContext: {
      pageTitle: 'Field Editor',
      subTitle: 'Wähle Feld Context',
      breadcrumbTitle: 'Kontextliste',
      notice: {
        paragraph1: 'Jedes Customfield hat einen oder mehr Kontexte.',
        paragraph2: 'Ein Kontext kann dabei einem oder mehreren Projekten, sowie Vorgangstypen zugeordnet sein.',
        paragraph3: 'Klicke auf das ___ICON_EDIT___ Stift Icon, um die Optionen in einem spezifischen Kontext zu bearbeiten.',
        admin: {
          paragraph1: 'Als Administrator kannst du anderen Benutzern Berechtigungen erteilen.',
          paragraph2: 'Klicke auf das ___ICON_USERGROUP___ Benutzer Icon, um Benutzern oder Grupppen Berechtigungen für einen spezifischen Kontext des Customfields zu erteilen.',
        },
      },
      tableHead: {
        id: 'ID',
        name: 'Kontextname',
      },
      results: {
        noResultsOnFilter: 'Die Suche ergab keine Ergebnisse.',
        noResultsOnFilterDescription: 'Versuche einen anderen Suchbegriff einzutippen oder lösche den Suchfilter.',
        noResultsWithoutFilter: 'Keine Kontexte gefunden',
        noResultsWithoutFilterDescription: 'Das Feld hat keinen Kontext oder Du hast keine Felberechtigungen.',
      },
    },
  },

  rest: {
    http: {
      errorLabel: 'Fehler',
      errorDesc: 'Daten konnten nicht via REST API übertragen werden.',
    },
    validation400: {
      errorLabel: 'Validierungs Fehler',
      errorDesc: '---',
    },
    invalidlicense: {
      errorLabel: 'App license problem',
    },
    gatewaytimeout504: {
      errorLabel: 'Fehler',
      errorDesc: 'Die App kann die REST API nicht erreichen. Bitte lade die Seite neu.',
    },
    unauthorized401: {
      errorLabel: 'Fehler',
      errorDesc: 'Die App kann die REST API nicht erreichen. Bist du eingeloggt? Bitte lade die Seite neu.',
    },
    forbidden403: {
      errorLabel: 'Fehler',
      errorDesc: 'Du hast keine Berechtigung, um diese Seite anzuzeigen.',
    },
  },
  permissionEditorListPage: {
    notice: {
      paragraph1: 'Der Berechtigungs Editor zeigt alle unterstützen Customfields mit ihren Berechtigungen an.',
      paragraph2: 'Filtere mit Hilfe der Suche nach der Customfield ID, dem Namen oder der Beschreibung.',
      paragraph3:
        'Klicke auf das ___ICON_EDIT___ Stift Icon, um Benutzern und Gruppen globale Berechtigungen oder kontext-spezifische Berechtigungen zu erteilen, damit diese die Customfield Optionen selbstständig editieren können.',
      paragraph4: 'Klicke auf das ___ICON_USERGROUP___ zeige Benutzer/Gruppen Icon, um einen schnellen Überblick über die bereits erteilten Berechtigungen zu erhalten.',
    },
    globalPermission: {
      isSet: 'Globale Berechtigungen erteilt',
      isNotSet: 'Keine Globale Berechtigungen erteilt',
    },
    contextPermission: {
      isSet: 'Kontext Berechtigungen erteilt',
      isNotSet: 'Keine Kontext Berechtigungen erteilt',
    },
  },
  editPermissionsPage: {
    noContextInCustomfield: {
      title: 'Kein Context vorhanden',
      details:
        'Ein Feld ohne Context ist für Benutzer im Feld Editor nicht editierbar. Legen sie über die Jira Administrationsoberfläche für Benutzerdefinierte Felder einen Standard oder Projekt Context an.',
    },
    placeholders: {
      groupPermissions: 'Gruppen',
      userPermissions: 'Benutzer',
      typeToSeeUsers: 'Beginne zu tippen, um nach Benutzern zu suchen',
      typeToSeeGroups: 'Beginne zu tippen, um nach Gruppen zu suchen',
    },
    emptyMessage: {
      groupTitle: 'Keine Berechtigungen vorhanden',
      groupDescription: 'Beginne zu tippen, um nach Gruppen zu suchen und Berechtigungen zu vergeben',
      userTitle: 'Keine Berechtigungen vorhanden',
      userDescription: 'Beginne zu tippen, um nach Benutzern zu suchen und Berechtigungen zu vergeben',
    },
    globalPermissions: {
      notice: {
        paragraph1:
          'Editiere Customfield Berechtigungen und vergebe globale Berechtigungen an Benutzer und Gruppen. Globale Berechtigungen gelten für alle Kontexte des ausgewählten Customfields. Die berechtigten Benutzer und Gruppenmitglieder können somit die Customfield Optionen in jeglicher Weise modifizieren:',
        paragraph2: 'Optionen hinzufügen, bestehende Optionen editieren, Optionen löschen, Optionen aktivieren/deaktivieren und die Reihenfolge festlegen.', // FIXME: Optionen alphabetisch sortieren und einen Standardwert setzen.',
      },
    },
    contextPermissions: {
      headline: 'Kontext Berechtigungen',
      notice: {
        paragraph1:
          'Editiere Customfield Berechtigungen und vergebe Kontext Berechtigungen an Benutzer und Gruppen. Kontext Berechtigungen gelten für einen spezifischen Kontext des ausgewählten Customfields. Die berechtigten Benutzer und Gruppenmitglieder können somit Customfield Optionen in jeglicher Weise modifizieren:',
        paragraph2: 'Optionen hinzufügen, bestehende Optionen editieren, Optionen löschen, Optionen aktivieren/deaktivieren und die Reihenfolge festlegen.', // FIXME: Optionen alphabetisch sortieren und einen Standardwert setzen.',
        paragraph3: 'Falls für Benutzer oder Gruppen bereits globale Customfield Berechtigungen gesetzt wurden, greifen die Kontext Berechtigungen für diese Benutzer und Gruppen nicht.',
      },
    },
  },
  fieldEditor: {
    emptyOptionsListMessage: 'Es gibt noch keine Customfield Optionen.',
    scrollToTop: 'Zum Anfang',
    scrollToBottom: 'Zum Ende',
    notice: {
      paragraph1: 'Editiere Customfield Optionen nach deinen Anforderungen:',
      paragraph2: 'Füge Optionen hinzu, editiere bestehende Optionen oder lösche Optionen.',
      paragraph3: 'Aktiviere Optionen oder deaktiviere die Optionen, die du in Jira Vorgängen verbergen willst.',
      paragraph4: 'Ändere die Reihenfolge einfach per drag-and-drop; die Reihenfolge wird genauso in Jira Vorgängen verwendet.',
      paragraph5: 'Setze einen ___ICON_DEFAULT___ Standardwert, der in der Vorauswahl von Jira Vorgängen erscheinen soll.',
    },
    editChildOptions: 'Editiere Kind-Optionen',
    defaultOptionIsSetInChildOptions: 'Setze den Standardwert in den Kind-Optionen',
    deleteDefaultOptionButton: 'Lösche Standardwert',
    editConfirm: {
      yes: 'Speichern',
      no: 'Abbrechen',
    },
    deleteConfirm: {
      yes: 'Endgültig löschen',
      no: 'Nicht löschen',
      tooltip: 'Option löschen',
      tooltipDisabledDuePermission: 'Option löschen deaktiviert (nur aktiviert für Administratoren)',
    },
    editOption: {
      duplicateError: 'Option existiert bereits. Optionen müssen einzigartig sein',
      duplicateErrorShort: 'Duplikat',
    },
    table: {
      optionvalue: 'Optionswert',
      default: 'Standard',
      disabled: 'Aktiviert',
      childoptions: 'Kind-Opt.',
    },
    defaultOption: {
      tooltip: 'Zeige aktuellen Standardwert',
      headline: 'Standardwert',
      isNotDefault: 'Setze Standardwert',
      isDefault: 'Ist bereits Standardwert',
      noDefaultValue: '- kein Standardwert -',
      types: {
        select: 'Radio Buttons: hat einen einzelnen Standardwert.',
        radiobuttons: 'Select List (single choice): hat einen einzelnen Standardwert.',
        multiselect: 'Select List (multiple choices): hat mehrere Standardwerte.',
        multicheckboxes: 'Checkboxes: hat mehrere Standardwerte.',
        cascadingselect: 'Select List (cascading): Jede Option hat Kind-Optionen. Standarwert besteht aus Eltern- und Kindoption. Die Kindoption ist optional!',
      },
    },
    newOption: {
      addButton: 'Hinzufügen',
      placeholder: 'Neue Option hinzufügen',
    },
    refresh: 'Aktualisieren',
    sort: {
      headline: 'Sortiere Optionen alphabetisch in der Datenbank',
      strength: {
        title: 'Stärke',
        titleTooltip: 'Legt fest wie ähnliche Zeichen beim Sortieren behandelt werden. Wenn sie unsicher sind, belassen sie es auf dem Standard.',
        primary: 'Akzente gleich, Groß/Klein gleich (a = ä, a = A)',
        secondary: 'Akzente ungleich, Groß/Klein gleich (a != ä, a = A)',
        tertiary: 'Akzente ungleich, Groß/Klein ungleich (a != ä, a != A)',
      },
      order: {
        title: 'Abfolge',
        titleTooltip: 'Legt fest ob die Liste A bis Z (aufsteigend) oder Z bis A (absteigend) sortiert wird.',
        ascending: 'aufsteigend',
        descending: 'absteigend',
      },
      locale: {
        title: 'Locale',
        titleTooltip: 'Sortieren ist sprachabhängig. Geben Sie ein Locale an, das der Sprache der Optionen entspricht. Im ISO 639 Format wie en-US.',
      },
      buttonDoSort: 'Sortieren',
    },
  },
};
